// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.app,
.content {
  height: 100%;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
}

.app {
  display: flex;
  position: relative;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #e0e0e0;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.comment {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: white;
}

.comment-avatar {
  margin-right: 16px;
  border-radius: 50%;
  opacity: 0.8;
}

.comment-info {
  flex: 1 1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.comment-username {
  font-size: 14px;
  font-weight: bold;
  color: black;
}

.comment-timestamp {
  font-size: 12px;
  color: #606060;
  margin-left: 8px;
}

.comment-reply-button {
  font-size: 12px;
  color: #606060;
  cursor: pointer;
  border: none;
  background-color: transparent;
}

.comment-text {
  font-size: 14px;
  color: black;
  line-height: 1.5;
}

.comment-replies {
  margin-left: 40px;
  margin-top: 8px;
  padding-left: 16px;
  border-left: 1px solid #e0e0e0;
}

.comment-reply {
  font-size: 12px;
  color: #606060;
}

.comment-thumbnail {
  margin-left: 16px;
  min-width: 100px;
  border-radius: 8px;
}

.comment-judul {
  font-size: 14px;
  color: black;
  margin-top: 8px;
}

.boxy:hover {
  box-shadow: none;
  transition: box-shadow 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap\");\r\n\r\nhtml,\r\nbody,\r\n#root,\r\n.app,\r\n.content {\r\n  height: 100%;\r\n  width: 100%;\r\n  font-family: \"Source Sans Pro\", sans-serif;\r\n}\r\n\r\n.app {\r\n  display: flex;\r\n  position: relative;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: #e0e0e0;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.comment {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding: 16px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background-color: white;\r\n}\r\n\r\n.comment-avatar {\r\n  margin-right: 16px;\r\n  border-radius: 50%;\r\n  opacity: 0.8;\r\n}\r\n\r\n.comment-info {\r\n  flex: 1;\r\n}\r\n\r\n.comment-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.comment-username {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: black;\r\n}\r\n\r\n.comment-timestamp {\r\n  font-size: 12px;\r\n  color: #606060;\r\n  margin-left: 8px;\r\n}\r\n\r\n.comment-reply-button {\r\n  font-size: 12px;\r\n  color: #606060;\r\n  cursor: pointer;\r\n  border: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.comment-text {\r\n  font-size: 14px;\r\n  color: black;\r\n  line-height: 1.5;\r\n}\r\n\r\n.comment-replies {\r\n  margin-left: 40px;\r\n  margin-top: 8px;\r\n  padding-left: 16px;\r\n  border-left: 1px solid #e0e0e0;\r\n}\r\n\r\n.comment-reply {\r\n  font-size: 12px;\r\n  color: #606060;\r\n}\r\n\r\n.comment-thumbnail {\r\n  margin-left: 16px;\r\n  min-width: 100px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.comment-judul {\r\n  font-size: 14px;\r\n  color: black;\r\n  margin-top: 8px;\r\n}\r\n\r\n.boxy:hover {\r\n  box-shadow: none;\r\n  transition: box-shadow 0.3s;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
